//
// Export the moment lib with twix applied
// Twix relies on moment being globally scoped
//
import moment from 'moment';
import 'imports-loader?moment!vendor/moment.extend.js.coffee';
import 'imports-loader?moment!twix';

export default moment;



// WEBPACK FOOTER //
// ./app/javascript/lib/vendor_extensions/moment_extended.js